import { render, staticRenderFns } from "./RecordingDetectedModal.vue?vue&type=template&id=1328fc26&scoped=true"
import script from "./RecordingDetectedModal.vue?vue&type=script&lang=js"
export * from "./RecordingDetectedModal.vue?vue&type=script&lang=js"
import style0 from "./RecordingDetectedModal.vue?vue&type=style&index=0&id=1328fc26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1328fc26",
  null
  
)

export default component.exports